export const CONSENT_COOKIE_NAME = 'asst_cookie_consent';
export const CONSENT_STORAGE_KEY = 'asst_cookie_consent';
export const CONSENT_VERSION = 1;
/** Consent preference lifetime in days */
export const CONSENT_MAX_AGE_DAYS = 180;

export const CONSENT_CATEGORIES = {
  necessary: 'necessary',
  externalContent: 'externalContent',
} as const;

export type ConsentCategory =
  (typeof CONSENT_CATEGORIES)[keyof typeof CONSENT_CATEGORIES];

export const OPTIONAL_CONSENT_CATEGORIES: ConsentCategory[] = [
  CONSENT_CATEGORIES.externalContent,
];
